import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import s from './Avantages.module.css';

gsap.registerPlugin(ScrollTrigger);

export default function Avantages() {
  const sectionRef = useRef(null);
  const gridRef = useRef(null);
  const titleRef = useRef(null);
  const subtitleRef = useRef(null);
  

  const avantages = [
    {
      id: '01',
      tag: 'Précision',
      title: 'Détection Précise du Bétail',
      description: 'Modèles IA entraînés sur des données réelles, offrant une haute précision dans la détection des animaux sur tous types de terrains.',
    },
    {
    id: '02',
    tag: 'Vitesse',
    title: 'Analyse Multi-Sources',
    description: 'Traitement instantané de vos flux, qu’il s’agisse d’images terrestres (photos mobiles, drones) ou de données satellites.',
    },
    {
    id: '03',
    tag: 'Sécurité',
    title: 'Confidentialité Totale',
    description: 'Vos données d’exploitation sont protégées par un système de chiffrement avancé garantissant l’intégrité de votre historique.',
    },
    {
      id: '04',
      tag: 'Rapports',
      title: 'Rapports Structurés',
      description: 'Générez automatiquement des exports CSV ou PDF détaillés pour votre suivi historique.',
    },
    {
    id: '05',
    tag: 'Accessibilité',
    title: 'Disponibilité Partout',
    description: 'Une plateforme optimisée pour rester accessible et performante, quelle que soit votre localisation ou la qualité de votre réseau.',
    },
    {
    id: '06',
    tag: 'Multi-Zones',
    title: 'Gestion Multi-Zones',
    description: 'Supervisez simultanément plusieurs parcs ou zones de pâturage pour une vision globale de votre exploitation.',
    }
  ];

useEffect(() => {
  const ctx = gsap.context(() => {
    
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: sectionRef.current,
        start: "top 90%",    // Déclenche l'entrée un peu plus tôt
        end: "bottom 20%",   // Point de référence pour la sortie
        toggleActions: "play none none reverse",
      }
    });

    // 1. Titre arrive de GAUCHE
    tl.from(titleRef.current, {
      x: -150,
      opacity: 0,
      duration: 1.2,
      ease: "power4.out",
    })

    // 2. Sous-titre arrive de DROITE
    .from(subtitleRef.current, {
      x: 150,
      opacity: 0,
      duration: 1.2,
      ease: "power4.out",
    }, "-=0.8") 

    // 3. Apparition des cartes avec effet de rebond
    .from(gridRef.current.children, {
      y: 60,
      opacity: 0,
      duration: 0.8,
      stagger: 0.1,
      ease: "back.out(1.7)",
    }, "-=0.5");

  }, sectionRef);

  return () => ctx.revert();
}, []);

  return (
    <section ref={sectionRef} id="benefits" className={s.avantagesSection}>
      <div className={s.container}>
        <div className={s.header}>
          <h2 className={s.mainTitle} ref={titleRef}>
            Avantages Clés
          </h2>
          <p className={s.subtitle} ref={subtitleRef}>
            Découvrez pourquoi notre plateforme de détection de bétail révolutionne la gestion de l'élevage moderne
          </p>
        </div>

        <div ref={gridRef} className={s.grid}>
          {avantages.map((item) => (
            <div key={item.id} className={s.card}>
              <div className={s.cardTop}>
                <span className={s.id}>{item.id}</span>
                <span className={s.tag}>{item.tag}</span>
              </div>
              <div className={s.cardContent}>
                <h3 className={s.cardTitle}>{item.title}</h3>
                <p className={s.cardDesc}>{item.description}</p>
              </div>
              <div className={s.glow}></div>
              <div className={s.hoverLine}></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}